<script>
  //域名
  //let baseDomainUrl = "http://127.0.0.1:81";
  // let baseServerPath = "http://127.0.0.1:8889";
  //let businessServerPath = "http://127.0.0.1:8888";
  // let modelServerPath = "http://127.0.0.1:8890";

  let baseDomainUrl = "http://web.biaima.com.cn";
  let baseServerPath = "http://web.biaima.com.cn:8889";
  let businessServerPath = "http://web.biaima.com.cn:8888";
  let modelServerPath = "http://web.biaima.com.cn:8890";

  let basePhotoPath = baseDomainUrl + "/static/file/image";
  let baseFilePath = baseDomainUrl + "/static/file/file";
  let baseDocumentPath = baseDomainUrl + "/static/file/document";

  import {roleFuns, proSearch} from '../api/api'
  //设置请求头
  let user = sessionStorage.getItem('user');//当前用户
  user = JSON.parse(user);
  let header = {};
  let fileHeader = {};
  let proList = [];
  let funs = null;

  if (user != null) {

    header = {headers: {'token': user.token}};//请求头;
    fileHeader = {token: user.token}
    //初始化登录用户所在的项目集合
    let pros = user.projectName;
    if (pros != null && pros.length > 0) {
      proList = JSON.parse(pros);
    } else {
      getProList(user);
    }
    //获取登录用户拥有功能集合
    if (user.roleId != null) {
      getFuns(user);
    }
  }

  function getFuns(user) {
    $.ajax({
      url: baseServerPath + '/sysmanager/fun/rolefuns',
      type: "POST",
      data: JSON.stringify({key: user.roleId}),
      cache: false,
      dataType: 'json',
      headers: {token: user.token, 'Content-Type': 'application/json;charset=utf8'},
      async: false,  //同步方式发起请求
      success: function (result) {
        funs = result.data;
      }
    });
  }

  function getProList(user) {
    let params = {
      page: 1,
      limit: 10000,
      comId: user.comId == '' ? null : user.comId
    };//请求参数
    $.ajax({
      url: baseServerPath + '/sysmanager/project/search',
      type: "POST",
      data: JSON.stringify(params),
      cache: false,
      dataType: 'json',
      headers: {token: user.token, 'Content-Type': 'application/json;charset=utf8'},
      async: false,  //同步方式发起请求
      success: function (result) {
        proList = result.data.result;
      }
    });
  }

  //验证登录用户权限 （抽象方法 嫁接到 所有操作方法中）
  function checkRole(fun, option, _this) {

    if (funs != null && user.status != -1) {
      let isR = false;
      for (let j = 0; j < funs.length; j++) {//这是岗位下对应的功能集合
        let keyCode = funs[j].keyCode;//功能键值
        let op = funs[j].optionKey == null ? [] : funs[j].optionKey.split(',');

        for (let k = 0; k < op.length; k++) {//这是岗位下对应某一功能的操作集合
          if (fun == keyCode && option == op[k]) {

            isR = true;
            break;
          }
        }
      }
      if (!isR) {
        _this.$alert('您的权限不足', {
          type: 'warning',
          confirmButtonText: '确定',
          callback: action => {
            _this.$router.push('/welcome');
          }
        });
        return false;
      } else {
        return true;
      }
    }
    if (user.status == -1) {
      return true;
    }
    return false;
  }

  //标记权限验证
  function checkRoleTag(tag, _this) {
    let is = true;
    if (funs != null && user.status != -1) {
      for (let i = 0; i < funs.length; i++) {
        if (funs[i].status == tag) {
          is = false;
          break;
        }
      }
      if (is) {
        let mes = '您的权限不足,您不拥有';
        switch (tag) {
          case 0:
            mes = mes + '项目经理岗位标记！';
            break;
          case 1:
            mes = mes + '工种岗位标记！';
            break;
          case 2:
            mes = mes + '班组岗位标记！';
            break;
          case 3:
            mes = mes + '部门岗位标记！';
            break;
          case 4:
            mes = mes + '安全员岗位标记！';
            break;
          case 5:
            mes = mes + '质量员岗位标记！';
            break;
          case 6:
            mes = mes + '施工员岗位标记！';
            break;
          case 7:
            mes = mes + '技术员岗位标记！';
            break;
          case 8:
            mes = mes + '材料员岗位标记！';
            break;
          case 9:
            mes = mes + '仓库管理员岗位标记！';
            break;
          case 10:
            mes = mes + '塔吊司机岗位标记！';
            break;
          case 11:
            mes = mes + '塔吊指挥岗位标记！';
            break;
          default:
            return
        }
        _this.$alert(mes, {
          type: 'warning',
          confirmButtonText: '确定',
          callback: action => {
            _this.$router.push('/welcome');
          }
        });
        return;
      }
    }
  }

  let safeType = 1;
  let qualityType = 2;

  //功能枚举=========================
  //功能
  let fun = {
    company: 'com',//公司管理
    project: 'pro',//项目管理
    role: 'role',//岗位角色
    user: 'user',//实名制管理
    qualityDisclose: 'qd',//质量交底
    qualityRectify: 'qr',//质量整改
    safeDisclose: 'sd',//安全交底
    safeRectify: 'sr',//安全整改
    deviceRegister: 'dr',//设备注册
    deviceEnc: 'denc',//资料管理
    deviceCheck: 'dcheck',//设备维保与检查
    techDrawing: 'tdr',//图纸管理
    techChange: 'tch',//变更管理
    projectMes: 'pmes',//工程动态
    examCreate: 'ec',//创建考试
    examDo: 'ed',//在线考试
    gwp: 'gwp',//雾炮
    gtdpl: 'gtdpl',//塔吊喷淋
    gwqpl: 'gwqpl',//围墙喷淋
    gdlpl: 'gdlpl',//道路喷淋
    gdd: 'gdd',//镝灯
    gtynld: 'gtynld',//太阳能路灯
    techModel:'tm',//模型管理
    progress:'progress',//进度管理
    tower:'tower',//塔吊布局
  }
  //操作
  let option = {
    create: 'c',//添加
    update: 'u',//修改
    select: 'r',//查询
    delete: 'd',//删除
    message: 'm',//详情
    status: 's',//更改状态
    check:'p',//对比
  }
  //功能枚举end=======================
  //岗位标记
  let roleTag = {
    pm: 0,//项目经理
    workKind: 1,// 1工种
    workTeam: 2,// 2 班组
    department: 3,// 3 部门
    safer: 4,// 4 安全员
    quality: 5,// 5 质量员
    construction: 6,// 6 施工员
    technology: 7,// 7 技术员
    material: 8,// 8 材料员
    warehouse: 9,//仓库
    craneDriver: 10,//塔吊司机
    craneCommander: 11,//塔吊指挥
  }
  //通用数据枚举
  let command = {
    sortProject: 'sort',//分项工程
    special: 'special',//专业
    question: 'question',//问题类型
  }


  // 对Date的扩展，将 Date 转化为指定格式的String
  // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
  // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
  // (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
  // (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
  Date.prototype.Format = function (fmt) {
    var o = {
      "M+": this.getMonth() + 1,                 //月份
      "d+": this.getDate(),                    //日
      "h+": this.getHours(),                   //小时
      "m+": this.getMinutes(),                 //分
      "s+": this.getSeconds(),                 //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }

  function formatTimeToStr(times, pattern) {
    var d = new Date(times).Format("yyyy-MM-dd hh:mm:ss");
    if (pattern) {
      d = new Date(times).Format(pattern);
    }
    return d.toLocaleString();
  }

  function getURLParam(paraName) {
    let url = document.location.toString()
    let arrObj = url.split('?')
    if (arrObj.length > 1) {
      let arrPara = arrObj[1].split('&')
      let arr
      for (let i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split('=')
        if (arr != null && arr[0] == paraName) {
          return arr[1]
        }
      }
      return ''
    } else {
      return ''
    }
  }

  function fuzzySearch(zTreeId, searchField, isHighLight, isExpand){
    let zTreeObj = $.fn.zTree.getZTreeObj(zTreeId);//get the ztree object by ztree id
    if(!zTreeObj){
      alert("fail to get ztree object");
    }
    let nameKey = zTreeObj.setting.data.key.name; //get the key of the node name
    isHighLight = isHighLight===false?false:true;//default true, only use false to disable highlight
    isExpand = isExpand?true:false; // not to expand in default
    zTreeObj.setting.view.nameIsHTML = isHighLight; //allow use html in node name for highlight use

    let metaChar = '[\\[\\]\\\\\^\\$\\.\\|\\?\\*\\+\\(\\)]'; //js meta characters
    let rexMeta = new RegExp(metaChar, 'gi');//regular expression to match meta characters

    // keywords filter function
    let oldParent = [];
    function ztreeFilter(zTreeObj,_keywords,callBackFunc) {
      if(!_keywords){
        _keywords =''; //default blank for _keywords
      }
      // function to find the matching node
      function filterFunc(node) {

        //名称
        if(node && node.oldname && node.oldname.length>0){
          node[nameKey] = node.oldname;
        }
        //构件ID
        if(node && node.externalid && node.externalid.length>0){
          node["externalId"] = node.externalid;
        }
        zTreeObj.updateNode(node);
        if (_keywords.length == 0) {
          zTreeObj.showNode(node);
          zTreeObj.expandNode(node,isExpand);
          oldParent= [];
          return true;
        }
        if ((node[nameKey] && node[nameKey].toLowerCase().indexOf(_keywords.toLowerCase())!=-1)
              || (node["externalId"] && node["externalId"].toLowerCase().indexOf(_keywords.toLowerCase())!=-1)) {
          let children  = node.children;
          oldParent.push(node.glid);
          if(children!=null){
            for (let i = 0; i < children.length; i++) {
              oldParent.push(children[i].glid);
            }
          }
          return true;
        }
        else {
          if(oldParent.indexOf(node["pglid"])!=-1){
            let children  = node.children;
            if(children!=null){
              for (let i = 0; i < children.length; i++) {
                oldParent.push(children[i].glid);
              }
            }
            return true;
          }
        }
        zTreeObj.hideNode(node);
        return false;
      }
      let nodesShow = zTreeObj.getNodesByFilter(filterFunc); //get all nodes that would be shown

      processShowNodes(nodesShow, _keywords);//nodes should be reprocessed to show correctly
    }

    function processShowNodes(nodesShow,_keywords){
      if(nodesShow && nodesShow.length>0){
        if(_keywords.length>0){
          $.each(nodesShow, function(n,obj){
            let pathOfOne = obj.getPath();
            if(pathOfOne && pathOfOne.length>0){
              for(let i=0;i<pathOfOne.length-1;i++){
                zTreeObj.showNode(pathOfOne[i]); //show node
                zTreeObj.expandNode(pathOfOne[i],false); //expand node
              }
            }
          });
        }
      }
    }

    //listen to change in input element
    $(searchField).bind('keydown', function(e) {
      let _keywords =$.trim($(this).val());
      if(e.keyCode==13 && _keywords.length>0){
        $(".loading_view").show()
        $(searchField).attr("disabled",true);
        oldParent = [];
        searchNodeLazy(_keywords);
      }
    });
    // $(searchField).bind('input propertychange', function() {
    //   let _keywords = $(this).val();
    //   if(_keywords.length==0){
    //     $(".loading_view").show()
    //     $(searchField).attr("disabled",true);
    //     searchNodeLazy(_keywords);
    //
    //   }
    // });

    let timeoutId = null;
    let lastKeyword = '';
    function searchNodeLazy(_keywords) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(function() {
        if (lastKeyword === _keywords) {
          return;
        }
        ztreeFilter(zTreeObj,_keywords);
        $(".loading_view").hide();
        hasTreeSearch = true;
        $(searchField).attr("disabled",false);
        lastKeyword = _keywords;
      }, 500);
    }
  }
  export default {
    baseServerPath,
    formatTimeToStr,
    header,
    fileHeader,
    safeType,
    qualityType,
    user,
    basePhotoPath,
    baseDocumentPath,
    baseDomainUrl, baseFilePath,
    checkRole,
    fun,
    option,
    roleTag,
    command,
    businessServerPath,
    proList,
    checkRoleTag,
    modelServerPath,
    getURLParam,
    fuzzySearch,
  }
</script>



// WEBPACK FOOTER //
// src/components/Global.vue